/**
 * The EA Cart Drawer app lists line item property values without their keys ("Test" instead of "Name: Test").
 * This tags each value line with its key so CSS in layout/theme.liquid can print the label.
 * The app's lines carry no item id, so an item's values are matched as a consecutive run of lines.
 */
function labelProperties() {
  const lines = Array.from(document.querySelectorAll('#ea-sticky-cart-root .ea-normalLineHeight'));
  lines.forEach((line) => line.removeAttribute('data-property-label'));

  for (const item of window.eaSCart?.items ?? []) {
    const properties = Object.entries(item.properties ?? {}).filter(([key]) => !key.startsWith('_'));
    if (properties.length === 0) continue;

    const start = lines.findIndex((_, i) =>
      properties.every(([, value], j) => lines[i + j]?.textContent === String(value))
    );
    if (start === -1) continue;

    lines.splice(start, properties.length).forEach((line, j) => {
      line.setAttribute('data-property-label', properties[j][0]);
    });
  }
}

let frame = 0;
new MutationObserver(() => {
  cancelAnimationFrame(frame);
  frame = requestAnimationFrame(labelProperties);
}).observe(document.body, { childList: true, subtree: true, characterData: true });
